import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function Arvo({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: '深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕',
      date: '2026-06-07',
      desc: '6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！',
      img: '/images/news/twoCitiesAcademic2.jpg',
      route: '/newsInfo/twoCitiesAcademic'
    },
    {
      title: 'Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案',
      date: '2026-06',
      desc: '北京时间 2021 年 12 月 14 日，国际顶级学术期刊《Cell Reports》在线发表了由复旦大学附属眼耳鼻喉科医院文雯团队和中科院生物物理所张朋团队领衔的研究成果《成人人类弱视中膝状 - 纹状与皮质 - 顶盖通路的层选择性信号缺失与增强》。该研究联合 3T 和 7T 超高分辨率 BOLD fMRI 技术，结合精心设计的大细胞（M）/ 小细胞（P）通路特异性视觉刺激，对 17 名单侧弱视成人患者和 17 名正常对照者进行了对照研究，取得了里程碑式的发现',
      img: '/images/news/cellReportsAmblyopia5.jpg',
      route: '/newsInfo/cellReportsAmblyopia'
    },
    {
      title: '出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制',
      date: '2026-06',
      desc: '津门聚智，睛启新篇！备受行业瞩目的2026视觉健康创新发展国际会议（Vision China 2026）近日在天津圆满落幕。',
      img: '/images/news/jishiAllAgeAmblyopia8.jpg',
      route: '/newsInfo/jishiAllAgeAmblyopia'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.08</span>
              </div>
              <div className="article_titleBottom">ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                复旦大学附属眼耳鼻喉科医院眼科孙兴怀教授、刘红主任、文雯博士与美国加州大学的李响博士合作，将增强现实和双眼训练相结合，研发了一种双眼分视的训练新模式并用于成年弱视，
                训练模式包括一个带有双镜头的头戴式显示器和处理器，该双镜头实时捕捉环境图像，经处理器处理后分别投射到双眼前的显示屏上，其中弱视眼和健眼接受的图像对比度不同，
                并且双眼图像信息完整性不一（如下图）。患者佩戴该显示器后进行正常生活工作，需要整合双眼信息后才可以完成日常视觉任务从而达到弱视眼的视觉训练。经过四周左右的训练，
                大部分患者的弱视眼视力和不良的双眼间抑制均有所改善。该研究的初步结果（A dichoptic augmented-reality paradigm as a treatment for adult amblyopes）在2017年ARVO作大会发言交流，
                并被ARVO评为热点（Hot Topic）之一。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/arvo1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                视觉系统由出生到成熟需要经历漫长的发育过程，婴儿出生时，视力不及人的1%，随着年龄的不断增长，
                双眼视细胞不断发育和完善。6岁以内是视功能发育的重要时期，如这个时期某种原因造成双眼视物障碍，
                婴幼儿被迫接受异常的视觉输入，导致视觉通路的发育异常，弱视便会发生。
                <br />
                <br />
                由于弱视是视觉发育相关疾病，因此弱视的治疗与年龄相关，年龄越小，疗效越好，传统观念认为错过视觉
                敏感期（12岁以下）的弱视患者疗效较差，可能造成终生视觉缺陷。然而，无论患者的年龄大小都应当进行治疗。
                <br />
                <br />
                弱视临床治疗”金标准“——遮盖疗法已有200余年历史，迄今为止依旧被认为是最有效的弱视治疗手段，
                但其仍存在诸多弊端，如：依从性不佳、易回退、用于大龄青少年和成人弱视治疗几乎无效等。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/arvo2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                遮盖疗法的原理是通过遮盖优势眼从而强迫弱视眼使用，一般认为传统的遮盖治疗对成人弱视患者无效，但是最新生理学研究提示成人大脑仍具有可塑性。
                这明显与目前成人弱视治疗几乎无效不相符。近年来一系列研究提示单眼弱视的原发病因不再是双眼同视功能异常（binocular dysfunction），
                即弱视患者患弱视眼的视力障碍是继发于异常的双眼间抑制（interocular suppression）。目前常用的遮盖疗法或单眼知觉学习均旨在重塑弱视眼视路而忽略了作为原发因素的不良双眼交互作用，
                这有可能是传统治疗方法效果回退或不能达到视力完全康复的主要原因，因此解除弱视患者的眼间抑制，帮助弱视眼建立视觉解析能力可能是治疗成人单眼弱视的关键因素。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/invest'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/twoCitiesAcademic'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/invest'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/twoCitiesAcademic'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
